































































































import { Component, Mixins, Ref, Watch } from "vue-property-decorator";
import GrpTargetSelect from "@/components/GrpTargetSelect.vue";
import {
  AdcontrolProfile,
  AgentModuleConfiguration,
  Target,
  User,
} from "@/models";
import DatePicker, {
  DATE_FORMAT,
  DatePickerData,
} from "@/components/DatePicker.vue";
import VSwitchButton from "@/components/VSwitchButton.vue";
import MultiLevelSelect from "@/components/MultiLevelSelect.vue";
import MultiLevelObject from "@/interfaces/MultiLevelObject";
import CompetitorsTable from "@/components/Agencies/CompetitorsTable.vue";
import AgentCompetitorsTable from "@/components/Agencies/AgentCompetitorsTable.vue";
import CompetitorsTotals from "@/components/Agencies/CompetitorsTotals.vue";
import { Getter, Mutation } from "vuex-class";
import QueryHelper from "@/services/QueryHelper";
import CompetitorsReportMixin, {
  GET_REPORT,
} from "@/mixins/http/Agencies/CompetitorsReport";
import AgentModuleConfigurationMixin, {
  AgentModuleConfigurationMixinTags,
} from "@/mixins/http/Agencies/AgentModuleConfigurationMixin";
import CompetitorsReportRecord from "@/models/interfaces/Competitors";
import JsFileDownloader from "js-file-downloader";
import { FEATURE_AUDITEL } from "@/constants";
import MeMixin from "@/mixins/http/Agencies/Me";
import ClientUserInfo from "@/models/Agents/UserInfo";
import { ProfileCapabilitiesService } from "@/services/Profile/CapabilitiesService";
import PageGuide, { GuidePaths } from "@/components/PageGuide.vue";
import { formatApiDate } from "@/services/ApiDateHelper";

const requestTag = "clientsAgentModuleConfigurations";
@Component({
  components: {
    GrpTargetSelect,
    DatePicker,
    VSwitchButton,
    MultiLevelSelect,
    CompetitorsTable,
    AgentCompetitorsTable,
    CompetitorsTotals,
    PageGuide,
  },
})
export default class CompetitorsReport extends Mixins(
  CompetitorsReportMixin,
  MeMixin,
  AgentModuleConfigurationMixin
) {
  currentGrpTarget: Target | null = null;
  visualizationOptions: MultiLevelObject[] = [
    {
      id: "all",
      text: "Tutto",
    },
    {
      id: "inclusion",
      text: "Solo inclusions",
    },
    {
      id: "exceptions",
      text: "Solo exceptions",
    },
    {
      id: "exclusive",
      text: "Solo exclusives",
    },
  ];

  @Ref() showSelector!: MultiLevelSelect;

  data: CompetitorsReportRecord[] = [];
  agentModuleConfiguration: AgentModuleConfiguration | null = null;
  maxDate = "";

  loading = false;
  weeklyData = false;
  dateStart = "";
  dateEnd = "";
  showAgentsData = false;

  filter = {
    date: "",
    weeklyData: false,
    show: "all",
  };

  guidePath = GuidePaths.AGENCIES_COMPETITOR_REPORT;

  onChangedAgentsView(value: boolean) {
    this.setAgentView(value);
  }

  get queryFilter() {
    return {
      date: this.parseDateValue(this.filter.date),
      show: this.filter.show || "all",
      weeklyData: `${this.filter.weeklyData}`,
    };
  }

  buildFilterFromQuery() {
    const query = this.$route.query;
    const date = query.date || this.$moment().format(DATE_FORMAT);
    const show = (query.show as string) || "all";
    return {
      date: this.parseDateValue(date as string),
      weeklyData: query.weeklyData == "true",
      show,
    };
  }

  parseDateValue(date: string) {
    if (this.$moment(date).isAfter(this.$moment(this.maxDate))) {
      return this.maxDate;
    }

    return this.$moment(date).format(DATE_FORMAT);
  }

  get percentage() {
    return this.totals.startsSeconds
      ? (this.totals.inclusionSeconds * 100) / this.totals.startsSeconds
      : 0;
  }

  totals = {
    starts: 0,
    startsSeconds: 0,
    startsVod: 0,
    startsVodTv: 0,
    exclusive: 0,
    exclusiveSeconds: 0,
    exclusiveVod: 0,
    exclusiveVodTv: 0,
    exception: 0,
    exceptionSeconds: 0,
    exceptionVod: 0,
    exceptionVodTv: 0,
    inclusion: 0,
    inclusionSeconds: 0,
    inclusionVod: 0,
    inclusionVodTv: 0,
    sov: 0,
  };

  @Getter("profile") readonly profile!: AdcontrolProfile;
  @Getter("auth/accessToken") readonly token!: string;
  @Getter("user") readonly user!: User;
  @Getter("lastDate") readonly lastDate!: string;
  @Getter("agentView") readonly settingsAgentView!: boolean;
  @Getter("agentUserInfos") readonly agentUserInfo!: ClientUserInfo;
  @Mutation("setAgentView") setAgentView!: (view: boolean) => void;

  @Watch("filter", { deep: true })
  async onFilterChanged() {
    const isEqual = QueryHelper.isSameQuery(
      this.$route.query,
      this.queryFilter
    );
    if (!isEqual) {
      this.$router.replace({ query: { ...this.queryFilter } });
    }
    await this.loadData();
  }

  @Watch("$store.state.settings.profile")
  async onProfileChanged() {
    await this.loadData();
  }

  @Watch("$store.state.settings.agentView")
  async onSettingsChanged(value: boolean) {
    this.showAgentsData = value;
    await this.loadData();
  }

  async loadMaxDate() {
    const resp = await this.getProfileLastDate(this.profile.slug, requestTag);
    if (resp.meta.date) {
      this.maxDate = formatApiDate(resp.meta.date, DATE_FORMAT);
    }
  }

  @Watch("filter.date")
  onFilterDateChanged(value: string) {
    this.dateStart = this.$moment(value)
      .subtract(6, "days")
      .format("DD/MM/YYYY");
    this.dateEnd = this.$moment(value).format("DD/MM/YYYY");
  }

  get showGrp(): boolean {
    return (
      this.isTv && (this.user.profile?.hasFeature(FEATURE_AUDITEL) || false)
    );
  }

  get isTv(): boolean {
    return this.profile.accountType === "tv";
  }

  async onTargetSelected(target: Target) {
    this.currentGrpTarget = target;
    await this.loadMaxDate();
    await this.loadData();
  }

  get grpTargetId() {
    if (this.isTv) {
      const id = this.currentGrpTarget?.id;
      if (id) {
        return id;
      }
      return (
        localStorage.getItem("GrpTargetSelect-target") ||
        localStorage.getItem("a-target")
      );
    } else {
      return null;
    }
  }

  async created() {
    await this.loadMaxDate();
    this.filter = this.buildFilterFromQuery();
    this.showAgentsData = this.settingsAgentView;
    await this.loadData();
  }

  get excelUrl(): string {
    let filters: {
      date: string;
      weeklyData: boolean;
      agentModuleView?: string;
    } = {
      date: this.filter.date,
      weeklyData: this.filter.weeklyData,
    };
    if (this.showAgentsData && this.agentSuperUser) {
      filters = {
        ...filters,
        agentModuleView: "ok",
      };
    }
    return this.getCompetitorsExcelUrl(
      this.profile.slug,
      this.profile.accountType,
      filters,
      this.grpTargetId
    );
  }

  get showAgentCompetitorTable(): boolean {
    return (
      this.hasAgentModule && (!this.agentSuperUser || this.settingsAgentView)
    );
  }

  get hasAgentModule(): boolean {
    return ProfileCapabilitiesService.agentsModuleEnabled(
      this.user.profile,
      this.agentUserInfo
    );
  }

  get showAgent(): boolean {
    return this.hasAgentModule && this.agentSuperUser;
  }

  get agentSuperUser(): boolean {
    return this.agentUserInfo?.superUser || false;
  }

  async loadData() {
    this.loading = true;
    let filters: {
      date: string;
      weeklyData: boolean;
      agentModuleView?: string;
    } = {
      date: this.filter.date,
      weeklyData: this.filter.weeklyData,
    };
    if (this.showAgentsData && this.agentSuperUser) {
      filters = {
        ...filters,
        agentModuleView: "ok",
      };
    }

    if (this.hasAgentModule) {
      try {
        this.agentModuleConfiguration = await this.getAgentModuleConfiguration(
          AgentModuleConfigurationMixinTags.GetAgentModuleConfiguration,
          this.profile.slug
        );
      } catch (e) {
        this.agentModuleConfiguration = null;
      }
    }

    const loadedData: CompetitorsReportRecord[] =
      await this.getCompetitorsReport(
        this.profile.slug,
        this.profile.accountType,
        filters,
        GET_REPORT,
        this.grpTargetId
      );

    loadedData.forEach((element) => {
      element.sov = 0;
      if (element.seconds > 0) {
        element.sov = Math.round((element.my_seconds / element.seconds) * 100);
      }
      element.exclusive =
        element.my_seconds == element.seconds && element.seconds > 0
          ? "exclusive"
          : "no";
      element.exclusive =
        element.my_vod_presence == element.vod_presence &&
        element.seconds == 0 &&
        element.my_vod_presence > 0
          ? "exclusive_vod"
          : element.exclusive;
      element.exclusive =
        element.my_vod_presence + element.my_seconds ==
          element.vod_presence + element.seconds &&
        (element.my_vod_presence ?? 0) > 0 &&
        element.seconds > 0
          ? "exclusive_vod_tv"
          : element.exclusive;
    });

    this.valorizeData([...loadedData]);
    this.assignTotals([...loadedData]);
    this.loading = false;
  }

  valorizeData(loadedData: CompetitorsReportRecord[]) {
    switch (this.filter.show) {
      case "inclusion":
        this.data = loadedData.filter((element) => {
          return element.inclusion == "inclusion";
        });
        break;
      case "exceptions":
        this.data = loadedData.filter((element) => {
          return element.inclusion == "exception";
        });
        break;
      case "exclusive":
        this.data = loadedData.filter((element) => {
          return element.exclusive?.startsWith("exclusive");
        });
        break;
      default:
        this.data = loadedData;
    }
  }

  assignTotals(loadedData: CompetitorsReportRecord[]) {
    this.totals = {
      starts: 0,
      startsSeconds: 0,
      startsVod: 0,
      startsVodTv: 0,
      exclusive: 0,
      exclusiveSeconds: 0,
      exclusiveVod: 0,
      exclusiveVodTv: 0,
      exception: 0,
      exceptionSeconds: 0,
      exceptionVod: 0,
      exceptionVodTv: 0,
      inclusion: 0,
      inclusionSeconds: 0,
      inclusionVod: 0,
      inclusionVodTv: 0,
      sov: 0,
    };

    this.totals.starts = loadedData.length;
    this.totals.startsSeconds = loadedData.reduce((acc, el) => {
      if (el.count === 0) {
        this.totals.startsVod += (el.vod_presence ?? 0) > 0 ? 1 : 0;
      } else {
        this.totals.startsVodTv += (el.vod_presence ?? 0) > 0 ? 1 : 0;
      }
      if (el.inclusion == "inclusion") {
        this.totals.inclusion += 1;
        this.totals.inclusionSeconds += el.my_seconds;
        if (el.my_count === 0) {
          this.totals.inclusionVod += (el.my_vod_presence ?? 0) > 0 ? 1 : 0;
        } else {
          this.totals.inclusionVodTv += (el.my_vod_presence ?? 0) > 0 ? 1 : 0;
        }
        this.totals.exceptionSeconds += el.seconds - el.my_seconds;
      }
      if (el.inclusion == "exception") {
        this.totals.exception += 1;
        this.totals.exceptionSeconds += el.seconds;
        if (el.seconds === 0) {
          this.totals.exceptionVod += (el.vod_presence ?? 0) > 0 ? 1 : 0;
        } else {
          this.totals.exceptionVodTv += (el.vod_presence ?? 0) > 0 ? 1 : 0;
        }
      }
      if (el.exclusive == "exclusive") {
        this.totals.exclusive += 1;
        this.totals.exclusiveSeconds += el.my_seconds;
      }
      if (el.exclusive == "exclusive_vod") {
        this.totals.exclusiveVod += 1;
      }
      if (el.exclusive == "exclusive_vod_tv") {
        this.totals.exclusiveVodTv += 1;
      }
      acc += el.seconds;
      return acc;
    }, 0);
    this.totals.sov = this.totals.startsSeconds
      ? Math.round(
          (this.totals.inclusionSeconds * 100) / this.totals.startsSeconds
        )
      : 0;
  }

  onShowSelected(element: MultiLevelObject) {
    this.filter.show = element.id;
  }

  onDateChanged(dateSelected: DatePickerData) {
    this.filter.date = this.$moment(dateSelected.date).format(DATE_FORMAT);
  }

  onDownload() {
    new JsFileDownloader({
      url: this.excelUrl,
      headers: [
        {
          name: "Authorization",
          value: `Bearer ${this.token}`,
        },
      ],
    });
  }
}
